import { render, staticRenderFns } from "./hubWiseRVPReport_KSA_new.vue?vue&type=template&id=1b5def50&"
import script from "./hubWiseRVPReport_KSA_new.vue?vue&type=script&lang=js&"
export * from "./hubWiseRVPReport_KSA_new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports